import { tv } from 'tailwind-variants';

const fullscreenSheetStyles = tv({
    slots: {
        overlay: `
      iris:fixed
      iris:inset-0
      iris:z-[100]
      iris:bg-(--comp-color-background-sheet-scrim-default)
    `,
        wrapper: `
      iris:fixed
      iris:inset-0
      iris:z-[101]
      iris:flex
      iris:w-full
      iris:justify-center
    `,
        content: `
      iris:relative
      iris:flex
      iris:h-[100dvh]
      iris:max-h-[100dvh]
      iris:min-h-[100dvh]
      iris:w-full
      iris:max-w-[767px]
      iris:flex-col
      iris:bg-(--comp-color-background-sheet-sheet-default)
      iris:focus-visible:ring-2
      iris:focus-visible:ring-(--sem-color-border-interactive-selected)
      iris:focus-visible:ring-offset-0
      iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
      iris:focus-visible:outline-none
    `,
        header: `
      iris:flex
      iris:w-full
      iris:justify-start
      iris:bg-(--comp-color-background-sheet-sheet-default)
      iris:py-(--comp-space-padding-fullscreen-sheet-header-vertical)
      iris:pr-(--comp-space-padding-fullscreen-sheet-header-right)
      iris:pl-(--comp-space-padding-fullscreen-sheet-header-left)
    `,
        headerInner: `
      iris:flex
      iris:w-full
      iris:items-center
      iris:justify-center
      iris:gap-(--base-space-px-8)
    `,
        backButton: `
      iris:flex
      iris:h-(--comp-size-icon-sheet-header)
      iris:w-(--comp-size-icon-sheet-header)
      iris:items-center
      iris:justify-center
    `,
        backIcon: `
      iris:size-(--comp-size-icon-sheet-header)
      iris:text-(--comp-color-content-sheet-header-icon-rest)
    `,
        headerSlot: `
      iris:align-center
      iris:flex
      iris:w-full
      iris:flex-1
      iris:items-center
      iris:justify-center
      iris:pl-(--base-space-px-8)
    `,
        body: `
      iris:flex
      iris:flex-1
      iris:flex-col
      iris:overflow-y-auto
      iris:px-(--comp-space-padding-fullscreen-sheet-horizontal)
      iris:pt-(--comp-space-padding-bottom-sheet-all)
      iris:pb-(--comp-space-padding-bottom-sheet-all)
    `,
        footer: `
      iris:flex
      iris:w-full
      iris:flex-shrink-0
      iris:bg-(--comp-color-background-sheet-sheet-default)
      iris:p-(--comp-space-padding-bottom-sheet-all)
    `,
    },
    variants: {
        fixedFooter: {
            true: {
                body: `
          iris:pb-(--comp-space-padding-bottom-sheet-all)
        `,
                footer: `
          iris:border-t
          iris:border-t-(--comp-color-border-sheet-default)
        `,
            },
        },
        breakpoint: {
            sm: {
                overlay: "iris:sm:hidden",
                wrapper: "iris:sm:hidden",
            },
            md: {
                overlay: "iris:md:hidden",
                wrapper: "iris:md:hidden",
            },
            lg: {
                overlay: "iris:lg:hidden",
                wrapper: "iris:lg:hidden",
            },
            xl: {
                overlay: "iris:xl:hidden",
                wrapper: "iris:xl:hidden",
            },
            "2xl": {
                overlay: "iris:2xl:hidden",
                wrapper: "iris:2xl:hidden",
            },
        },
    },
    defaultVariants: {
        breakpoint: "md",
    },
});

export { fullscreenSheetStyles as default, fullscreenSheetStyles };
